import React, { FC } from 'react';
import cn from 'classnames';
import { FiX } from 'react-icons/fi';
import css from '../../../styles.module.scss';
import i18n from '../../../../../i18n';

type AlertErrorTextProps = {
  errorText?: string;
};

const AlertError: FC<AlertErrorTextProps> = ({
  errorText = i18n.t(`campaigns_page.campaigns_copy_modal.unknow_error`),
}) => (
  <div className={css.toast}>
    <div className={cn(css.icon, '_isError')}>
      <FiX size={16} color="#fff" />
    </div>
    <div className={cn(css.text, '_isError')}>{errorText}</div>
  </div>
);

export default AlertError;
